import { BoxGeometry, Mesh } from 'three';
import { appMixin } from '../../utils/appMixin';
import { BackgroundMaterial } from '../Materials/Background/material';

export class Background extends appMixin(Mesh) {
  constructor(app) {
    super(
      app,
      new BoxGeometry(20, 20, 20),
      new BackgroundMaterial({
        side: 1,
        depthTest: false,
        depthWrite: false,
        uniforms: {
          ...app.uniforms,
          tNoise: { value: app.tools.noise.linearTexture },
          uCoolEffectIntensity: app.coolEffectIntensity,
        },
      })
    );

    this.renderOrder = -1;
  }
}
